import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";
import { InputType } from "./LangTitleBox";
import { Input } from "@brg/input";

export const LangTitleWrapper = styled(FlexBox)<{ mainTitle?: boolean, orientation?: string, required?: boolean, alignItems?: 'center' | 'flex-start' | 'flex-end' }>`
    width: ${({orientation}) => (orientation === 'row') ? '180px' : 'none'};
    min-width: ${({orientation}) => (orientation === 'row') ? '180px' : 'none'};
    margin-right: ${({orientation}) => (orientation === 'row') ? '32px' : '0'};

    ${({ required }) => required && css`

    h6 {
        position: relative;
        margin-right: 17px !important;
        &::after {
            position: absolute;
            top: 3px;
            right: -8px;
            content: '*';
            display: block;
            color: #C64839;
        }
    }
    `};
    ${({ mainTitle, orientation, alignItems}) => mainTitle ? css`
        flex-flow: row;
        margin-bottom: 8px;


        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            margin-bottom: 0px;
        }

        @media(max-width: ${LayoutConst.screen.s - 1}px) {
            margin-bottom: 16px;
        }

    ` : css`
        flex-flow: ${orientation || 'column'};
        justify-content: ${orientation ? 'space-between' : 'normal'};
        align-items: ${alignItems ? alignItems : 'normal'};
        &::first-child {
            margin-right: 20px;
        }

        h6 {
            margin-bottom: 8px;
            margin-right: ${orientation === 'row' ? '8px' : 0};
            padding-top: ${orientation === 'row' ? '3px' : 0};
            // width: ${orientation === 'row' ? '100px' : 'auto'};
        }
    `}

    @media(max-width: ${LayoutConst.screen.m}px) {
        justify-content: space-between;
        flex-flow: row;
        place-items: center;
        width: 100%;
        margin-right: 22px;
        h6 {
            margin-bottom: 12px;
        }
    }
`;

export const LangBlockWrapper = styled(LangTitleWrapper)<{ inputType?: InputType, langVisible?: boolean}>`
    width: 100%;
    min-width: 100%;
    margin-right: 0;
    place-items: ${({ inputType }) => inputType === InputType.textarea ? 'start' : 'center'};

    .lang-label-block {
        margin-right: 24px;
    }

    textarea {
        min-height: 285px;
    }
    textarea::placeholder{
        font-size: 17px;
        line-height: 22px;
        @media(max-width: ${LayoutConst.screen.mac13}px){
            font-size: 15px;
            line-height: 20px;
        }
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        flex-flow: column !important;
        place-items: start;

        .lang-label-block {
            justify-content: space-between;
            width: 100%;
            margin: 0 0 8px 0;
        }
    }   
`;
export const StyledInput = styled(Input.Text)`
    &::placeholder {
        font-size: 17px !important;
        line-height: 22px !important;
        color: ${p => p.theme.designerEdit.inputs.placeholder} !important;
        color: ${p => p.theme.designerEdit.inputs.placeholder} !important;
        @media(max-width: ${LayoutConst.screen.mac13}px){
            font-size: 15px !important;
            line-height: 20px !important;
        }
    }
`;
export const StyledLinkInput = styled(StyledInput)`
    background-color: ${({theme}) => theme.competition.input.bg} !important;
    border-color: transparent !important;
`;

export const StyledTextarea = styled.textarea`
    scrollbar-width: 3px;
    &::placeholder {
        color: ${p => p.theme.designerEdit.inputs.placeholder} !important;
    }
    ::-webkit-scrollbar {
        width: 3px;
    }
    ::-webkit-scrollbar-thumb {
        background: #909090 !important;
    }

    outline: none;
    border: none;
    border-radius: 3px;
    padding: 16px 45px 21px 24px;
    font-size: 15px;
    line-height: 20px;

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        padding: 10px 16px;
        font-size: 13px;
        line-height: 16px;
    }
`

export const Title  = styled.h6<{ mainTitle?: boolean, orientation?: string }>`
    color: rgba(144, 144, 144, 1);
    margin: 0;
    position: relative;

    ${({ mainTitle}) => mainTitle ? css`
    font-size: 23px;
    line-height: 29px;
    font-weight: 600;
    margin-right: 16px;
    ` : css`
        font-size: 15px;
        line-height: 20px;
        font-weight: 400;
    `};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        ${({ mainTitle, orientation }) => mainTitle ? css`
        font-size: 23px;
        line-height: 29px;
        font-weight: 600;
        ` : css`
        font-size: 13px;
        line-height: 16px;
        font-weight: 400;
        `};
    }
`;

export const LangTitle = styled(Title)<{ langVisible?: boolean }>`
    width: ${({ langVisible }) => langVisible ? '90px' : '174px'};
    margin-right: ${({ langVisible }) => langVisible ? '16px' :  0} !important;
    position: relative;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
        width: ${({ langVisible }) => langVisible ? '70px' : '154px'};
    }
`;

export const LangContainer = styled(FlexBox)<{ orientation?: string, isGeograffee?: boolean }>`
    width: 100%;
    max-width: 68px;
    justify-content: space-between;
    border-radius: 3px;
    border: ${({isGeograffee}) => isGeograffee ? '1px solid rgba(142, 145, 147, 1)' : '1px solid rgba(182, 182, 181, 1)'};
    background:${({isGeograffee}) => isGeograffee ? '#3F4548' : 'rgba(242, 242, 242, 1)'};
    cursor: pointer;
    max-height: 28px;
`;

export const LangItem = styled.div<{ active?: boolean, lang: string, isCompetitionEdit?: boolean, isGeograffee?: boolean }>`
    font-size: 13px;
    line-height: 16px;
    font-weight: 600;
    max-width: 34px;

    background-color: ${({ isCompetitionEdit, isGeograffee, theme }) => isCompetitionEdit ? theme.competition.langComponent.notActive.bg : isGeograffee ? '#3F4548' : 'rgba(242, 242, 242, 1)'};
    color: ${({ isCompetitionEdit, isGeograffee, theme }) => isCompetitionEdit ? theme.competition.langComponent.notActive.color : isGeograffee ? '#8E9193' : 'rgba(112, 112, 111, 1)'};
    text-align: center;
    padding: 6px 8px;
    border-radius: 3px;

    ${({ active, lang, isCompetitionEdit, isGeograffee, theme }) => active && css`
        background-color: ${isCompetitionEdit ? theme.competition.langComponent.active.bg : isGeograffee ? '#63686B' : 'rgba(112, 112, 111, 1)'};
        color: ${isCompetitionEdit ? theme.competition.langComponent.active.color : isGeograffee ? '#FEFEFE' : 'rgba(254, 254, 254, 1)'};
        border: none;
        height: 28px;
        margin: -1px;
    `};
`;import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";
import { InputType } from "./LangTitleBox";
import { Input } from "@brg/input";

export const LangTitleWrapper = styled(FlexBox)<{ mainTitle?: boolean, orientation?: string, required?: boolean, alignItems?: 'center' | 'flex-start' | 'flex-end' }>`
    width: ${({orientation}) => (orientation === 'row') ? '180px' : 'none'};
    min-width: ${({orientation}) => (orientation === 'row') ? '180px' : 'none'};
    margin-right: ${({orientation}) => (orientation === 'row') ? '32px' : '0'};

    ${({ required }) => required && css`

    h6 {
        position: relative;
        margin-right: 17px !important;
        &::after {
            position: absolute;
            top: 3px;
            right: -8px;
            content: '*';
            display: block;
            color: #C64839;
        }
    }
    `};
    ${({ mainTitle, orientation, alignItems}) => mainTitle ? css`
        flex-flow: row;
        margin-bottom: 8px;


        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            margin-bottom: 0px;
        }

        @media(max-width: ${LayoutConst.screen.s - 1}px) {
            margin-bottom: 16px;
        }

    ` : css`
        flex-flow: ${orientation || 'column'};
        justify-content: ${orientation ? 'space-between' : 'normal'};
        align-items: ${alignItems ? alignItems : 'normal'};
        &::first-child {
            margin-right: 20px;
        }

        h6 {
            margin-bottom: 8px;
            margin-right: ${orientation === 'row' ? '8px' : 0};
            padding-top: ${orientation === 'row' ? '3px' : 0};
            // width: ${orientation === 'row' ? '100px' : 'auto'};
        }
    `}

    @media(max-width: ${LayoutConst.screen.m}px) {
        justify-content: space-between;
        flex-flow: row;
        place-items: center;
        width: 100%;
        margin-right: 22px;
        h6 {
            margin-bottom: 12px;
        }
    }
`;

export const LangBlockWrapper = styled(LangTitleWrapper)<{ inputType?: InputType, langVisible?: boolean}>`
    width: 100%;
    min-width: 100%;
    margin-right: 0;
    place-items: ${({ inputType }) => inputType === InputType.textarea ? 'start' : 'center'};

    .lang-label-block {
        margin-right: 24px;
    }

    textarea {
        min-height: 285px;
    }
    textarea::placeholder{
        font-size: 17px;
        line-height: 22px;
        @media(max-width: ${LayoutConst.screen.mac13}px){
            font-size: 15px;
            line-height: 20px;
        }
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        flex-flow: column !important;
        place-items: start;

        .lang-label-block {
            justify-content: space-between;
            width: 100%;
            margin: 0 0 8px 0;
        }
    }   
`;
export const StyledInput = styled(Input.Text)`
    &::placeholder {
        font-size: 17px !important;
        line-height: 22px !important;
        color: ${p => p.theme.designerEdit.inputs.placeholder} !important;
        color: ${p => p.theme.designerEdit.inputs.placeholder} !important;
        @media(max-width: ${LayoutConst.screen.mac13}px){
            font-size: 15px !important;
            line-height: 20px !important;
        }
    }
`;
export const StyledLinkInput = styled(StyledInput)`
    background-color: ${({theme}) => theme.competition.input.bg} !important;
    border-color: transparent !important;
`;

export const StyledTextarea = styled.textarea`
    scrollbar-width: 3px;
    &::placeholder {
        color: ${p => p.theme.designerEdit.inputs.placeholder} !important;
    }
    ::-webkit-scrollbar {
        width: 3px;
    }
    ::-webkit-scrollbar-thumb {
        background: #909090 !important;
    }

    outline: none;
    border: none;
    border-radius: 3px;
    padding: 16px 45px 21px 24px;
    font-size: 15px;
    line-height: 20px;

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        padding: 10px 16px;
        font-size: 13px;
        line-height: 16px;
    }
`

export const Title  = styled.h6<{ mainTitle?: boolean, orientation?: string }>`
    color: rgba(144, 144, 144, 1);
    margin: 0;
    position: relative;

    ${({ mainTitle}) => mainTitle ? css`
    font-size: 23px;
    line-height: 29px;
    font-weight: 600;
    margin-right: 16px;
    ` : css`
        font-size: 15px;
        line-height: 20px;
        font-weight: 400;
    `};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        ${({ mainTitle, orientation }) => mainTitle ? css`
        font-size: 23px;
        line-height: 29px;
        font-weight: 600;
        ` : css`
        font-size: 13px;
        line-height: 16px;
        font-weight: 400;
        `};
    }
`;

export const LangTitle = styled(Title)<{ langVisible?: boolean }>`
    width: ${({ langVisible }) => langVisible ? '90px' : '174px'};
    margin-right: ${({ langVisible }) => langVisible ? '16px' :  0} !important;
    position: relative;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
        width: ${({ langVisible }) => langVisible ? '70px' : '154px'};
    }
`;

export const LangContainer = styled(FlexBox)<{ orientation?: string, isGeograffee?: boolean }>`
    width: 100%;
    max-width: 68px;
    justify-content: space-between;
    border-radius: 3px;
    border: ${({isGeograffee}) => isGeograffee ? '1px solid rgba(142, 145, 147, 1)' : '1px solid rgba(182, 182, 181, 1)'};
    background:${({isGeograffee}) => isGeograffee ? '#3F4548' : 'rgba(242, 242, 242, 1)'};
    cursor: pointer;
    max-height: 28px;
`;

export const LangItem = styled.div<{ active?: boolean, lang: string, isCompetitionEdit?: boolean, isGeograffee?: boolean }>`
    font-size: 13px;
    line-height: 16px;
    font-weight: 600;
    max-width: 34px;

    background-color: ${({ isCompetitionEdit, isGeograffee, theme }) => isCompetitionEdit ? theme.competition.langComponent.notActive.bg : isGeograffee ? '#3F4548' : 'rgba(242, 242, 242, 1)'};
    color: ${({ isCompetitionEdit, isGeograffee, theme }) => isCompetitionEdit ? theme.competition.langComponent.notActive.color : isGeograffee ? '#8E9193' : 'rgba(112, 112, 111, 1)'};
    text-align: center;
    padding: 6px 8px;
    border-radius: 3px;

    ${({ active, lang, isCompetitionEdit, isGeograffee, theme }) => active && css`
        background-color: ${isCompetitionEdit ? theme.competition.langComponent.active.bg : isGeograffee ? '#63686B' : 'rgba(112, 112, 111, 1)'};
        color: ${isCompetitionEdit ? theme.competition.langComponent.active.color : isGeograffee ? '#FEFEFE' : 'rgba(254, 254, 254, 1)'};
        border: none;
        height: 28px;
        margin: -1px;
    `};
`;